import { i18nMark } from 'lingui-react';

const formattedMessages = {
  accept: i18nMark('Accept'),
  amount: i18nMark('Amount'),
  approve: i18nMark('Approve'),
  comments: i18nMark('Comments'),
  decline: i18nMark('Decline'),
  error: i18nMark('Error'),
  estimates: i18nMark('Estimates'),
  estimateTotal: i18nMark('Estimate Total'),
  etr: i18nMark('ETR'),
  invoice: i18nMark('Invoice'),
  invoiceDate: i18nMark('Invoice Date'),
  invoiceId: i18nMark('Invoice Id'),
  optional: i18nMark('Optional'),
  po: i18nMark('Purchase Order'),
  provideANote: i18nMark('Provide a Note about your decision'),
  repairOrder: i18nMark('Repair Order'),
  submissionFailed: i18nMark('Your submission has failed.'),
  submit: i18nMark('SUBMIT'),
  title: i18nMark('Estimate/Invoice'),
  viewEstimate: i18nMark('View Estimate'),
  viewLatestEstimate: i18nMark('View Latest Estimate'),
};

export default formattedMessages;



// WEBPACK FOOTER //
// ./compositions/EstimateInvoicePendingWidget/messages.js